// extracted by mini-css-extract-plugin
module.exports = {"layout":"App_layout__22Ri1","layout_mobile":"App_layout_mobile__3gaCf","content":"App_content__3QKEx"};